import { setRosreestrObjectsInfoIsLoading, setRosreestrObjectsInfoModalIsShown } from "../../../../../../stateManagement/reducers";
import { store } from "../../../../../../stateManagement/store";
import { cursorStyleFunctions } from "../../../helpers";
import { getRosreestrObjectsInfo } from "../../rosreestrFunctions/rosreestrFunctions";

export async function rosreestrGetObjectsOnMapPoint(coordinate: any) {
    const rosreestrObjectsInfoIsLoading = store.getState().rosreestr.rosreestrObjectsInfoIsLoading
    if (!rosreestrObjectsInfoIsLoading) {
        const { zoom, projection } = store.getState().map.mapPosition
        cursorStyleFunctions.loading();
        store.dispatch(setRosreestrObjectsInfoIsLoading(true))
        store.dispatch(setRosreestrObjectsInfoModalIsShown(true))
        await getRosreestrObjectsInfo(coordinate, zoom, projection)
        store.dispatch(setRosreestrObjectsInfoIsLoading(false))
        cursorStyleFunctions.default();
    }
}